import { useEffect, useState } from "react";
import { timeAgo } from "../services/helperFunctions"; 
import silu from '../assets/silu.png';
import whats from '../assets/whats.png';
import Iframe from 'react-iframe';
import { isImageMessage } from "./Message"; // Import the function

function isPhoneNumber(str) {
  // Simple check: only digits, spaces, +, -, or ()
  return /^[\d\s+\-()]+$/.test(str);
}

const FeedChatButton = ({ message, currentChat, handleSelect }) => { 
  const [isSmallDevice, setIsSmallDevice] = useState(false);   

  useEffect(() => {
    const handleResize = () => setIsSmallDevice(window.innerWidth < 640);
    handleResize(); 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); 

  return ( 
    <div
      onClick={() => handleSelect(message)}
      className={`flex items-center gap-4 bg-white rounded-2xl shadow border border-neutral-200 px-5 py-4 transition-all duration-200 hover:shadow-lg hover:border-sky-300 cursor-pointer ${
        message.channel_id === currentChat.channel_id ? "ring-2 ring-sky-400 border-sky-300" : ""
      }`}
    >
      {/* Avatar or icon */}
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center text-sky-600 font-bold text-xl shadow">
        {isPhoneNumber(message.name)
          ? (
            <img
              className="h-12 w-10 rounded-full object-cover"
              src={message.category === 1 ? silu : whats}
              alt=""
            />
          )
          : (
            <img
              className="h-12 w-10 rounded-full object-cover"
              src={message.category === 1 ? silu : whats}
              alt=""
            />
          )
        }
      </div>
      {/* Chat info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <span className="font-semibold text-gray-800 truncate">{message.name}</span>
          <span className="text-xs text-gray-400 ml-2">{timeAgo(message.timestamp)}</span>
        </div>
        <div className="text-sm text-gray-500 truncate pt-1">
          {isImageMessage(message.message) ? (
            <img src={message.message} alt="media" className="max-h-12 rounded-md border border-neutral-200" />
          ) : message.message.includes("longitude") && message.message.includes("latitude") ? (
            <Iframe
              url={`//maps.google.com/maps?q=${
                typeof message.message === "string"
                  ? JSON.parse(message.message).latitude
                  : message.message.latitude
              },${
                typeof message.message === "string"
                  ? JSON.parse(message.message).longitude
                  : message.message.longitude
              }&z=15&output=embed`}
              width="100%"
              height="80px"
              className="border border-neutral-200 rounded-lg"
              style={{ minWidth: 100, maxWidth: 160 }}
              position="relative"
            />
          ) : (
            <span dangerouslySetInnerHTML={{ __html: message.message }} />
          )}
        </div>
      </div>
      {/* Unread badge */}
      {message.unread > 0 && message.direction === 0 && (
        <span className="ml-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow">
          {message.unread}
        </span>
      )}
    </div>
  );
};

export default FeedChatButton;
